import {upload, uploads} from '../../services/FileService';

export default {
  namespaced: true,
  actions: {
    async uploadFile ({commit, dispatch}, formData) {
      try {
        dispatch('library/isUploadingOn', {}, {root: true});
        await upload(formData);
      } catch (error) {
        dispatch('library/isUploadingOff', {}, {root: true});
        console.log(error);
        throw (error);
      }
    },
    async uploadFiles ({commit, dispatch}, formData) {
      try {
        dispatch('library/isUploadErrorOff', {}, {root: true});
        dispatch('library/isUploadingOn', {}, {root: true});
        await uploads(formData);
      } catch (error) {
        dispatch('library/isUploadErrorOn', {}, {root: true});
        dispatch('library/isUploadingOff', {}, {root: true});
        console.log(error);
        // throw (error);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/fileModule.js